import { openDB } from "idb";

export default async function (db_name) {
  const db = await openDB(db_name);
  const saves = await db.getAll(db_name);
  const size = saves.reduce((acc, cur) => acc + cur.byteLength, 0);
  db.close();
  return size;
}
